export const Rights = [
    "WEB_MODULE_HEALTH_SAFETY_ENVIRONMENT_WRITE"
]
